export const API_ROUTES = {
  GET_CURRENT_USER_PROFILE: "/accounts-school/profile/",
  UPDATE_CURRENT_USER_PROFILE: "/accounts-school/profile/",
  CHANGE_CURRENT_USER_AVATAR: "/accounts-school/change_avatar/",
  LOGIN_URL: "/accounts-school/login/",
  LOGOUT_URL: "/accounts-school/logout/",
  SEND_EMAIL_OTP_PASSWORD_RESET: "/accounts-school/request_new_password/",
  RESEND_EMAIL_OTP_PASSWORD_RESET:
    "/accounts-school/request_new_password/resend_code/",
  VERIFY_EMAIL_OTP_PASSWORD_RESET:
    "/accounts-school/request_new_password/verify_code/",
  CHANGE_PASSWORD: "/accounts-school/change_password/",
  FORCE_CHANGE_PASSWORD: "/accounts-school/reset_password/",
  GET_CURRENT_USER_DETAILS_URL: "/accounts-school/me/",
  GET_UNIVERSITIES: "/school/",
  GET_UNIVERSITY_BY_ID: "/school/{}/",
  CREATE_UNIVERSITY: "/school/{}/addresses/",
  CREATE_NEW_UNIVERSITY: "/school/",
  DELETE_UNIVERSITY: "/school/{}",
  UPDATE_UNIVERSITY_BY_ID: "/school/{}/",
  CHANGE_UNIVERSITY_LOGO: "/school/{}/change_logo/",
  GET_UNIVERSITY_LOCATIONS: "/school/{}/addresses/",
  GET_UNIVERSITY_LOCATION_BY_ID: "/school/{}/addresses/{}/",
  UPDATE_UNIVERSITY_LOCATION_BY_ID: "/school/{}/addresses/{}/",
  DELETE_UNIVERSITY_LOCATION_BY_ID: "/school/{}/addresses/{}/",
  GET_UNIVERSITY_USERS: "/school-users/",
  GET_DRILLDOWN_DATA: "/dashboard/university/analytical/results/assessment-get-by-type/",
  GET_UNIVERSITY_USER_BY_ID: "/school/{}/school-users/",
  DELETE_UNIVERSITY_USER: "/school-users/{}/",
  UPDATE_UNIVERSITY_USER: "/school-users/{}/",
  CREATE_UNIVERSITY_USER: "/school-users/",
  UPDATE_STATUS_UNIVERSITY_USER: "/school-users/{}/status/",
  CREATE_USER_BY_UNIVERSITY_ID: "/school/{}/school-users/",
  UPDATE_USER_BY_UNIVERSITY_ID: "/school/{}/school-users/{}/",
  GET_USER_BY_UNIVERSITY_ID: "/school/{}/school-users/{}/",
  DELETE_USER_BY_UNIVERSITY_ID: "/school/{}/school-users/{}/",
  GET_UNIVERSITY_USER_DETAIL_BY_ID: "/school-users/{}/",
  GET_UNIVERSITY_USERS_MANAGMENT: "/school-students/{}/",
  UPDATE_UNIVERSITY_STUDENT_DETAILS: "/school-student/{}/",
  CREATE_UNIVERSITY_STUDENT: "/school-students/{}/",
  IMPORT_BULK_STUDENTS: "/validate-import-school-student/{}/",
  IMPORT_BULK_STUDENTS_AFTER_VALIDATION: "/import-school-student/{}/",
  DOWNLOAD_STUDENTS: "/download-school-list/{}/",
  SINGLE_REMINDER: "/school-send-single-reminder/{}/",
  MULTIPLE_REMINDERS: "/school-send-multiple-reminders/{}/",
  DOWNLOAD_STUDENTS_TEMPLATE: "/school-students-excel-template-export/{}/",
  CREATE_ROLE: "/school-role/{}/",
  GET_ROLES: "/school-role/{}/",
  UPDATE_ROLE: "/school-role/{}/",

};
export const MASTERDATA_ROUTES = {
  ROLES_GET_URL: "/roles/",
  GET_COUNTRIES: "/scroll-list/all/loc/country/",
  GET_STATES_BY_CITIES: "/api/master/cities-by-country/",
  GET_STATES_BY_COUNTRY: "/scroll-list/hint/{}/state/",
  GET_CITY_BY_COUNTRY_AND_STATE: "/scroll-list/{}/{}/city/",
};
